import { Skeleton } from "@/shared/components/ui/skeleton";

export default function SpecificationSidebarSkeleton() {
  const SpecificationCard = () => {
    return (
      <div className="flex gap-2 w-full">
        <Skeleton className="w-[16px] h-[16px] rounded-sm" />
        <Skeleton className="w-full h-[16px] rounded-sm" />
      </div>
    );
  };

  const SpecificationItemCard = () => {
    return (
      <div className="flex gap-2 w-full">
        <Skeleton className="w-full h-[16px] rounded-sm" />
      </div>
    );
  };

  const SubCategoryCard = () => {
    return (
      <div className="pl-2 gap-[19px]">
        <SpecificationCard />
        <div className=" pl-2  flex flex-col mt-[19px] gap-[19px]">
          <SpecificationCard />
          <div className="pl-5 flex flex-col gap-[19px]">
            <SpecificationItemCard />
            <SpecificationItemCard />
          </div>
        </div>
      </div>
    );
  };
  return (
    <div className="flex flex-col justify-end gap-[21px] px-[5px]">
      <SpecificationCard />
      <SpecificationCard />
      <SpecificationCard />
      <SubCategoryCard />
      <SubCategoryCard />
      <div className="pl-5 gap-[19px]">
        <SpecificationCard />
      </div>
      <SpecificationCard />
      <SpecificationCard />
      <SpecificationCard />
      <SpecificationCard />
      <SpecificationCard />
      <SpecificationCard />
      <SpecificationCard />
      <SpecificationCard />
      <SpecificationCard />
      <SpecificationCard />
    </div>
  );
}
